import { HasFeeItem, HasOrderItems } from 'models/hasOrderItems/HasOrderItems';
import FormWithProvider from 'components/forms/form/Form';
import { Order } from 'models/Orders';
import { cancelledStatus } from 'utils/lead/leadUtils';
import useOrderViewFetchedData from '../useOrderViewFetchedData';
import OrderViewPriceDetailsInner from './OrderViewPriceDetailsInner';
import { OrderViewPriceDetailsInnerCollapseStyled } from './OrderViewPriceDetails.styles';
import GroupOrderViewPriceDetailsInner from './GroupOrderViewPriceDetailsInner';

const convertOrderToHasOrderItems = (order: Order): HasOrderItems => {
  return {
    ...order,
    fees: {
      // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      otherFees: order.fees.otherFees.map((fee) => {
        return {
          ...fee,
          enabled: true,
          removed: false,
        } as unknown as HasFeeItem;
      }),
      cleaningFee: {
        // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
        ...(order.fees.cleaningFee as unknown as HasFeeItem),
      },
    },
  };
};

const OrderViewPriceDetailsList = () => {
  const { lead } = useOrderViewFetchedData();

  const order: HasOrderItems = {
    // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    ...convertOrderToHasOrderItems(lead.order),
    // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    cancelled: cancelledStatus.includes(lead.status),
  };

  const subOrders: HasOrderItems[] =
    // @ts-expect-error TS18048 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    lead.order?.subOrders
      ?.map((subOrder) => {
        return {
          ...convertOrderToHasOrderItems(subOrder),
          propertyName: subOrder.propertyName,
          cancelled: subOrder.cancelled,
        };
      })
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName)) || [];

  return (
    <FormWithProvider onSubmit={() => {}}>
      {subOrders.length > 0 && (
        <GroupOrderViewPriceDetailsInner
          // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
          lead={lead}
          order={order}
          subOrders={subOrders}
          showCancelSubOrder={false}
          showSecurityDepositAsTotal
        />
      )}

      {subOrders.length === 0 && (
        <OrderViewPriceDetailsInner
          // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
          lead={lead}
          order={order}
          showAmountPaidRow
          showBalanceRow
        />
      )}

      {subOrders
        .filter((s) => !s.cancelled)
        .map((subOrder) => (
          <OrderViewPriceDetailsInnerCollapseStyled
            key={subOrder.uid}
            data-testid="sub-order-details"
            defaultExpanded={false}
            label={subOrder?.propertyName}
            variant="card"
          >
            <OrderViewPriceDetailsInner
              // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
              lead={lead}
              order={subOrder}
              showAmountPaidRow={false}
              showBalanceRow={false}
              showTitle={false}
              handleOrderAdjustment={false}
            />
          </OrderViewPriceDetailsInnerCollapseStyled>
        ))}
    </FormWithProvider>
  );
};

export default OrderViewPriceDetailsList;
